import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { v4_microsoft_mailbox_configure } from '../../actions/v4/mailBox';
import { toast } from 'react-toastify';
import constant from '../../constant';

const MicrosoftAuthCallBack = () => {
    const history = useHistory();   // ✅ correct hook

    const [status, setStatus] = useState('loading');
    const [error, setError] = useState('');
    const exchangeStartedRef = useRef(false);

    useEffect(() => {
        if (exchangeStartedRef.current) return;

        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const authorizationError = params.get('error_description') || params.get('error');

        if (authorizationError) {
            exchangeStartedRef.current = true;
            window.history.replaceState({}, document.title, window.location.pathname);
            setStatus('error');
            setError(authorizationError);
            return;
        }

        if (!code) {
            setStatus('error');
            setError('Authorization code not found. Start Microsoft login again.');
            return;
        }

        exchangeStartedRef.current = true;
        // Authorization codes are single use. Remove it before starting the exchange
        // so a refresh or StrictMode effect cannot submit the same code again.
        window.history.replaceState({}, document.title, window.location.pathname);
        exchangeCodeForToken(code);
    }, []);

    const exchangeCodeForToken = async (code) => {
        try {
            setStatus('loading');
            const response = await v4_microsoft_mailbox_configure({ authCode: code, redirect_uri: window.location.origin + '/auth/callback' })
            if (response.status) {
                setStatus('success');
                toast.success(response.result.message)                // ✅ redirect after success
                history.push(constant.Authedcomponent.mailBox.url);
            } else {
                throw new Error(response.error || 'Authentication failed');
            }
        } catch (err) {
            setStatus('error');
            setError(err.response?.data?.message || err.message);
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            {status === 'loading' && (
                <div className="text-center">
                    <h5>Signing you in with Microsoft…</h5>
                    <p>Please wait</p>
                </div>
            )}

            {status === 'success' && (
                <div className="text-center text-success">
                    <h5>Microsoft account connected successfully</h5>
                    <p>Redirecting…</p>
                </div>
            )}

            {status === 'error' && (
                <div className="text-center text-danger">
                    <h5>Microsoft Authentication Failed</h5>
                    <p>{error}</p>
                </div>
            )}
        </div>
    );
};

export default MicrosoftAuthCallBack;
